import { keys } from "lodash";

const EmotionColors = {
  love: "#46C122",
  joy: "#20D9B9",
  surprise: "#049DBF",
  fear: "#D98B25",
  sadness: "#A82B41",
  disgust: "#FFA17F",
  anger: "#DB3D50",
} as const;

export type Emotion = keyof typeof EmotionColors;

export function getEmotionColor(emotion: Emotion) {
  return EmotionColors[emotion];
}

export function getAllEmotions() {
  return keys(EmotionColors);
}
